import { render } from "./MarketplaceJobsubcategory.vue?vue&type=template&id=3c71f2ba&scoped=true"
import script from "./MarketplaceJobsubcategory.vue?vue&type=script&lang=js"
export * from "./MarketplaceJobsubcategory.vue?vue&type=script&lang=js"

import "./MarketplaceJobsubcategory.vue?vue&type=style&index=0&id=3c71f2ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c71f2ba"]])

export default __exports__